import { Grid } from '@material-ui/core';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { Async } from '../../../components/AsyncProvider';
import { Button } from '../../../components/Button/index';
import { Loading } from '../../../components/Loading/index';
import { SocialNetworks } from '../../../components/SocialNetworks';
import { IAsyncData } from '../../../models';
import { ROUTES } from '../../../router/consts';
import { IApplicationState } from '../../../store/models';
import { Container } from '../../Layout/components/Container';
import { setFooterVisibility } from '../../Layout/store/actions';
import { IContactDetails } from '../models';
import { ContactActions } from '../store/actions';

import './index.scss';

export const Contact: React.FC = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    React.useEffect(
        () => {
            dispatch(setFooterVisibility(false));
            dispatch(ContactActions.getConfig());

            return () => {
                dispatch(setFooterVisibility(true));
            };
        },
        [dispatch],
    );

    const contactDetailsBranch = useSelector<IApplicationState, IAsyncData<IContactDetails>>((state) => state.contact.configuration);

    return (
        <Container>
            <Helmet>
                <title>SCOUT - Contacts</title>
            </Helmet>
            <Async
                branch={contactDetailsBranch}
                deps={[contactDetailsBranch]}
                successRender={(data) => {
                    const { address_1, address_2, phone } = data;

                    return (
                        <Grid container justify="center">
                            <Grid item sm={8}>
                                <div className="contact-details">
                                    <h2 className="contact-details-title">Contacts</h2>
                                </div>
                                <Grid container justify="space-between">
                                    <Grid item sm={6} xs={12}>
                                        <div className="contact-section">
                                            <div className="contact-section-icon">
                                                <i className="icon-current" />
                                            </div>
                                            <div className="contact-section-details">
                                                <span>
                                                    {address_1}
                                                </span>
                                            </div>
                                            <div className="contact-section-location">
                                                <span>
                                                    {address_2}
                                                </span>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item sm={4} xs={12}>
                                        <div className="contact-section">
                                            <div className="contact-section-icon">
                                                <i className="icon-phone" />
                                            </div>
                                            <div className="contact-section-details">
                                                <span>
                                                    M <a href={`tel:${phone}`} >{phone}</a>
                                                </span>
                                            </div>
                                            <div className="contact-section-location">
                                                <SocialNetworks />
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid xs={12}>
                                    <div className="send-message">
                                        <Button onClick={() => history.push(ROUTES.CONTACT.SEND_MESSAGE)}>Send Message</Button>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                }}
                loadingRender={() => <Loading />}
            />
        </Container>
    );
};
